// extracted by mini-css-extract-plugin
export var resizer = "_ek-0";